module.exports = __webpack_public_path__ + "75288a03ff0af5360e7009e28f5e54d7.pdf";